import { defineStore } from 'pinia';
import { useBookingStore } from './bookingStore';
import { useMainStore } from './mainStore';
import Equipe from '@/classes/Equipe/Equipe.class';

export const useEquipesStore = defineStore('equipes', {
    state: () => ({
        list: []
    }),
    actions: {
        assign_teams() {
            const coureurs_to_assign = this.get_coureurs_to_assign();
            this.build_equipes(coureurs_to_assign);
        },

        get_coureurs_to_assign() {
            const bookingStore = useBookingStore();
            const inscriptions = bookingStore.inscriptions;
            if (!inscriptions) return [];
            let coureurs_to_assign = [];
            for (let i = 0; i < inscriptions.length; i++) {
                const inscription = inscriptions[i];
                let need_to_be_assign = false;
                const courses = inscription.get_courses();
                for (let j = 0; j < courses.length; j++) {
                    const course = courses[j];
                    if (course.is_equipe_course()) {
                        coureurs_to_assign.push({
                            index: i,
                            coureur: inscription.coureur.get_nom(),
                            course: course.id,
                            course_nom: course.nom,
                            size: course.get_equipe_size(),
                            equipe: inscription.get_equipe_name(),
                            extra_fields_equipe: inscription.get_extra_fields_equipe(),
                        });
                        need_to_be_assign = true;
                    }
                }
                if (!need_to_be_assign) {
                    delete inscriptions[i].coureur.equipe_name;
                }
            }
            return coureurs_to_assign;

        },


        build_equipes(coureurs_to_assign) {
            const coureurs_with_equipes = coureurs_to_assign.filter((coureur) => coureur.equipe != "");
            const coureurs_without_equipes = coureurs_to_assign.filter((coureur) => coureur.equipe == "");
            this.list = [];
            this.handle_coureurs_with_equipes(coureurs_with_equipes);
            this.handle_coureurs_without_equipes(coureurs_without_equipes);
        },

        handle_coureurs_with_equipes(coureurs_with_equipes) {
            for (let i = 0; i < coureurs_with_equipes.length; i++) {
                const coureur = coureurs_with_equipes[i];
                if (this.equipe_already_exist(coureur.equipe, coureur.course)) {
                    this.assign_coureur_to_equipe(coureur);
                } else {
                    this.create_new_equipe(coureur);
                }
            }
        },

        assign_coureur_to_equipe(coureur) {
            for (let i = 0; i < this.list.length; i++) {
                let equipe = this.list[i];
                if (equipe.nom == coureur.equipe && equipe.size > equipe.coureurs.length && equipe.id_course == coureur.course) {
                    equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
                }
            }
        },

        create_new_equipe(coureur) {
            const mainStore = useMainStore();
            let new_equipe = new Equipe();
            new_equipe.nom = coureur.equipe;
            new_equipe.size = coureur.size;
            new_equipe.id_course = coureur.course;
            new_equipe.nom_course = coureur.course_nom;
            new_equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
            new_equipe.set_extra_fields(mainStore.module.base, coureur.extra_fields_equipe);
            this.list.push(new_equipe);
        },

        handle_coureurs_without_equipes(coureurs_without_equipes) {
            let bookingStore = useBookingStore();
            for (let i = 0; i < coureurs_without_equipes.length; i++) {
                const coureur = coureurs_without_equipes[i];
                let assign = false;
                for (let j = 0; j < this.list.length; j++) {
                    let equipe = this.list[j];
                    if (equipe.size > equipe.coureurs.length && equipe.id_course == coureur.course) {
                        bookingStore.inscriptions[coureur.index].set_equipe_name(equipe.nom);
                        equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
                        assign = true;
                        break;
                    }
                }
                if (!assign) {
                    this.create_new_equipe(coureur);
                }
            }

        },

        /**
         * Checks if a team already exists in the list of teams for a given course and has available spots.
         *
         * @param {string} nom_equipe - The name of the team to check.
         * @param {number} id_course - The ID of the course to check.
         * @returns {boolean} - Returns true if the team exists and has available spots, otherwise false.
         */
        equipe_already_exist(nom_equipe, id_course) {
            return this.list.filter((equipe) => equipe.nom == nom_equipe && equipe.size > equipe.coureurs.length && equipe.id_course == id_course).length > 0;
        }
    },
    getters: {
        has_equipes() {
            return this.list.length > 0;
        },
        equipes_have_valid_names() {
            if (!this.has_equipes) return true;
            return this.all_coureurs_have_equipe_name && this.all_equipes_have_valid_name;
        },
        equipes_are_full() {
            if (!this.has_equipes) return true;
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].size > this.list[i].coureurs.length) {
                    return false;
                }
            }
            return true;
        },


        equipes_have_fields() {
            if (!this.has_equipes) return true;
            for (let i = 0; i < this.list.length; i++) {
                if (!this.list[i].has_complete_all_fields()) {
                    return false;
                }
            }
            return true;
        },

        all_coureurs_have_equipe_name() {
            const bookingStore = useBookingStore();
            for (let i = 0; i < bookingStore.inscriptions.length; i++) {
                let inscription = bookingStore.inscriptions[i];
                let courses = inscription.get_courses();
                for (let j = 0; j < courses.length; j++) {
                    let course = courses[j];
                    if (course.is_equipe_course()) {
                        if (inscription.coureur.equipe_name == "") {
                            return false;
                        }
                    }
                }
            }
            return true;
        },
        all_equipes_have_valid_name() {
            for (let i = 0; i < this.list.length; i++) {
                const nom_equipe = this.list[i].nom;
                if (nom_equipe == "") {
                    return false;
                }
                const authorizedPattern = /^[A-Z0-9+\-=/*#@%!?£€({[\]})|. ]+$/;
                // Check if the input string matches the authorized pattern
                if (authorizedPattern.test(nom_equipe)) {
                    // String contains only authorized characters
                    return true;
                } else {
                    // Find the first unauthorized character
                    const unauthorizedCharacter = nom_equipe.match(/[^A-Z0-9+\-=/*#@%!?£€({[\]})|. ]/)[0];
                    if (unauthorizedCharacter.match(/[a-z]/)) return false;
                    if (unauthorizedCharacter.match(/[ÀÁÂÃÄÅàáâãäåÈÉÊËèéêëÌÍÎÏìíîïÒÓÔÕÖØòóôõöøÙÚÛÜùúûü]/)) return false;
                    return false;
                }
            }
        }

    }
});